import React, { useState, useMemo } from "react";
import { getFormattedMessage } from "../../../../../helper/helpers";
import "./styles.scss";

export const RcsPreview = ({
  data,
  values,
  className = "rcs-preview-container",
  headers,
  sampleData,
  optOutMessage,
  enableOptOut,
}) => {
  const [imageError, setImageError] = useState(false);

  const cardData = data?.parsedContent?.types?.["twilio/card"];

  const formattedTitle = useMemo(
    () => {
      const templateTitle = cardData?.title || "";
      const placeholderRegex = /{{\s*([A-Z_]+)\s*}}/;
      const match = templateTitle.match(placeholderRegex);
      let textToFormat;
      if (match && values) {
        const placeholder = match[0];
        // Replace the placeholder with the user's custom text
        textToFormat = templateTitle.replace(placeholder, values);
      }
      // Check if the user is typing but there is NO placeholder
      else if (values) {
        // The custom text overrides the whole title
        textToFormat = values;
      }
      // Otherwise (user is not typing), just use the original template title
      else {
        textToFormat = templateTitle;
      }
      // Format the result (which is now either the original title or the new one)
      return getFormattedMessage(textToFormat, sampleData, headers);
    },
    [values, cardData, sampleData, headers]
  );
  const formattedSubtitle = useMemo(
    () => getFormattedMessage(cardData?.subtitle || "", headers),
    [cardData, headers]
  );

  if (!data) {
    return (
      <div className="no-template-selected">
        Select a template to see a preview
      </div>
    );
  }

  const mediaUrl = Array.isArray(cardData.media)
    ? cardData.media[0]
    : cardData.media?.url || cardData.media;

  return (
    <div className="rcs-card-preview">
      <div className="rcs-card-header">
        <div className="rcs-card-media-container">
          {mediaUrl && !imageError ? (
            <img
              src={mediaUrl}
              alt="Media content"
              className="rcs-card-media"
              onError={() => setImageError(true)}
            />
          ) : (
            <div className="rcs-media-placeholder">
              <h5 className="rcs-card-media-text">🖼️ Media not available</h5>
            </div>
          )}
        </div>
        <h3 className="rcs-card-title" style={{ whiteSpace: "pre-line" }}>
          {formattedTitle}
        </h3>

        {enableOptOut &&
          optOutMessage && <p className="rcs-card-title">{optOutMessage}</p>}

        {cardData.subtitle && (
          <p className="rcs-card-subtitle">{formattedSubtitle}</p>
        )}
      </div>

      <div className="rcs-card-actions">
        {cardData.actions?.map((action, index) => (
          <button
            key={`${action.id || index}`}
            className={`rcs-action-button ${action.type || ""}`}
            disabled
          >
            {action.title}
          </button>
        ))}
      </div>
    </div>
  );
};
